var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarReview(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5h-6V21h6v-1.5zM22.5 16.5h-9V18h9v-1.5zM22.5 13.5h-9V15h9v-1.5z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.412 8.413L12 1.5 8.588 8.413.96 9.52l5.52 5.381L5.176 22.5l5.324-2.798v-1.695l-3.33 1.751.922-5.38-3.909-3.81 5.401-.784L12 4.889l2.416 4.895 6.37.927L21 9.225l-5.588-.812z",
    fill: "#45464F"
  })));
}
export default SvgStarReview;